export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "gradient": {
    "title": "渐变色生成器",
    "subtitle": "创建精美的 CSS 渐变效果。线性、径向、圆锥。",
    "privacy": "100% 本地处理",
    "type": "类型",
    "linear": "线性",
    "radial": "径向",
    "conic": "圆锥",
    "angle": "角度",
    "stops": "颜色节点",
    "addStop": "添加",
    "random": "随机生成",
    "presets": "预设"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有渐变生成均在您的浏览器本地完成。任何设计数据都不会被上传到服务器。"
    },
    "guide": {
      "title": "如何使用渐变生成器",
      "description": "为网站、应用和设计项目创建精美的 CSS 渐变。",
      "steps": [
        {
          "title": "选择渐变类型",
          "description": "选择线性、径向或圆锥渐变类型。线性渐变最适合背景，径向渐变适合焦点区域，圆锥渐变适合色轮效果。"
        },
        {
          "title": "添加并排列颜色",
          "description": "点击添加色标点，然后拖动以沿渐变线定位。使用颜色选择器或输入 HEX 值以获得精确颜色。"
        },
        {
          "title": "复制 CSS 代码",
          "description": "将生成的 CSS 代码直接复制到您的样式表中。生成器生成符合标准且适用于所有现代浏览器的 CSS。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "线性、径向和圆锥渐变类型",
        "支持拖放交互式色标点定位",
        "可自定义角度和尺寸的实时预览",
        "可直接复制用于现代浏览器的 CSS 输出",
        "提供预设渐变，快速获取灵感",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的设计数据会被发送到服务器吗？",
          "answer": "不会。所有渐变生成和预览渲染均在您的浏览器本地完成。没有任何设计数据被传输或存储到外部。"
        },
        {
          "question": "哪些浏览器支持这些渐变？",
          "answer": "生成的 CSS 使用所有现代浏览器支持的标准语法，包括 Chrome、Firefox、Safari、Edge 和移动端浏览器。不支持 IE11。"
        },
        {
          "question": "可以将渐变导出为图片吗？",
          "answer": "目前该工具专注于为 Web 项目输出 CSS。如需导出图片，请截取屏幕截图后使用我们的图片转换器或图片调整大小工具。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "颜色转换器",
          "url": "/design/color-converter",
          "description": "在 HEX、RGB、HSL 和 CMYK 之间转换，支持对比度检查。"
        },
        {
          "name": "CSS 压缩工具",
          "url": "/developer/css-minifier",
          "description": "压缩 CSS 以减小文件大小，实现更快的页面加载。"
        },
        {
          "name": "图片调整大小工具",
          "url": "/image/image-resizer",
          "description": "调整图片大小以适应社交媒体、演示文稿和网页。"
        }
      ]
    }
  }
};
